<script setup lang="ts">
import { ref } from 'vue';
import { useUiStore } from '@/stores/UiStore.ts';

const emit = defineEmits(['toggled']);

const store = useUiStore();
const collapsedStore = store.sideMenuCollapsed;
const collapsed = ref(collapsedStore);

emit('toggled', collapsed.value);

function toggle(): void {
  collapsed.value = !collapsed.value;
  store.setSideMenuCollapsed(collapsed.value);

  emit('toggled', collapsed.value);
}
</script>

<template>
  <ul>
    <li
      @click="toggle"
      class="group relative flex items-center px-2 py-2 m-2
      hover:bg-gray-800 hover:rounded-md cursor-pointer select-none"
    >
      <div class="w-6 flex justify-center">
        <font-awesome-icon v-if="collapsed" class="fa-fw text-lg" icon="chevrons-right"/>
        <font-awesome-icon v-else class="fa-fw text-lg" icon="chevrons-left"/>
      </div>
    </li>
  </ul>
</template>

<style scoped>

</style>